export const Redirect_Url_1 = "https://mycard-web-th.line-apps.com/v1/starbucks/cards";
export const Redirect_Url_2 = "https://mycard-web-th.line-apps.com/v1/mycard/cards";
